import { ChangeDetectorRef, Injectable, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { dequal } from '../dequal/dequal';

import { TranslationService } from './translation.service';
import { TranslationParameter } from './translation.types';

@Pipe({
    name: 'translate',
    pure: false
})
@Injectable()
export class TranslatePipe implements PipeTransform, OnDestroy {
    private currentKey?: string;
    private currentTranslationParameter?: TranslationParameter;
    private translation = '';
    #subscription?: Subscription;
    #translateService = inject(TranslationService);
    #cdr = inject(ChangeDetectorRef);

    transform(key: string, translationParameter?: TranslationParameter): string {
        if (this.currentKey !== key || !dequal(this.currentTranslationParameter, translationParameter)) {
            this.unsubscribe();
            this.currentKey = key;
            this.currentTranslationParameter = translationParameter;
            this.#subscription = this.#translateService.translate(key, translationParameter).subscribe(t => {
                this.translation = t;
                this.#cdr.markForCheck();
            });
        }
        return this.translation;
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

    private unsubscribe() {
        if (this.#subscription) {
            this.#subscription.unsubscribe();
        }
    }
}
